import { Card, Shimmer } from '@betterment/samba-react';

export function MessageCardLoader() {
  return (
    // TODO: Remove bottom margin. Parent component should handle layout spacing.
    <Card css={{ mb: { base: 'space.100', md: 'space.300' } }} data-testid="messageCardLoader">
      <Card.Content css={{ p: 'space.300', display: 'grid', gap: 'space.200' }}>
        <Shimmer css={{ height: 'size.250', width: '260px' }} />
        <Shimmer css={{ height: 'size.250', width: '200px' }} />
      </Card.Content>
    </Card>
  );
}
